module.exports = __webpack_public_path__ + "static/media/VideoPrestige.83d3d2fe.svg";